module.exports = __webpack_public_path__ + "imgs/leaf-header-background-2.81d71637a68ce0e7956274a7a6a576ab.svg";